import { Icons } from '@/assets/icons/icons';
import { cn } from '@/lib/utils';

export const ConnectedBadge = ({ className }: { className: string }) => (
  <span
    className={cn(
      'absolute flex items-center justify-center rounded-full bg-success-9 text-white',
      className
    )}
  >
    <Icons.check className="size-2/3" />
  </span>
);
